<template>
    <tr class="substance-row">
        <td>
            <div v-if="readonly">{{ materialLabel || '-' }}</div>
            <div v-else class="text-muted">{{ materialLabel || '-' }}</div>
        </td>
        <td>
            <div v-if="readonly">{{ componentName || '-' }}</div>
            <div v-else class="text-muted">{{ componentName || '-' }}</div>
        </td>
        <template v-if="layout === 'component-first'">
            <td>
                <div v-if="readonly">
                    {{ materialWeightDisplay }}
                </div>
                <div v-else class="text-muted">
                    {{ materialWeightDisplay }}
                </div>
            </td>
            <FmdSubstanceFieldCell
                :value="substanceOption"
                :readonly="readonly"
                :display-name="substance.substanceName"
                :meta="substanceMeta"
                :allow-no-substance="allowNoSubstance"
                :no-substance="substance.noSubstance"
                :no-substance-label="noSubstanceLabel"
                :touched="touched"
                :error="substanceError"
                :search-fn="searchFn"
                :placeholder="substancePlaceholder"
                :start-typing-text="startTypingText"
                :no-options-text="noOptionsText"
                :request-add-text="requestAddText"
                :group="group"
                :is-substance-selected="isSubstanceSelected"
                @input="$emit('substance-select', group, substanceIndex, $event)"
                @request-add-substance="$emit('request-add-substance', group, substanceIndex, $event)"
            />
        </template>
        <template v-else>
            <FmdSubstanceFieldCell
                :value="substanceOption"
                :readonly="readonly"
                :display-name="substance.substanceName"
                :meta="substanceMeta"
                :allow-no-substance="allowNoSubstance"
                :no-substance="substance.noSubstance"
                :no-substance-label="noSubstanceLabel"
                :touched="touched"
                :error="substanceError"
                :search-fn="searchFn"
                :placeholder="substancePlaceholder"
                :start-typing-text="startTypingText"
                :no-options-text="noOptionsText"
                :request-add-text="requestAddText"
                :group="group"
                :is-substance-selected="isSubstanceSelected"
                @input="$emit('substance-select', group, substanceIndex, $event)"
                @request-add-substance="$emit('request-add-substance', group, substanceIndex, $event)"
            />
            <td>
                <div v-if="readonly">
                    {{ materialWeightDisplay }}
                </div>
                <div v-else class="text-muted">
                    {{ materialWeightDisplay }}
                </div>
            </td>
        </template>
        <FmdSubstanceWeightCell
            :substance="substance"
            :substance-weight-display="substanceWeightDisplay"
            :substance-weight-error="substanceWeightError"
            :no-substance="substance.noSubstance"
            :no-substance-label="noSubstanceLabel"
            :readonly="readonly"
            :touched="touched"
            :edit-key="`${group.localKey}:${substance.rowId || substanceIndex}`"
            @input="$emit('substance-weight-change', group, substance, $event)"
            @editing="$emit('weight-editing', $event)"
        />
        <td v-if="showComment">
            <div v-if="readonly">
                {{ substance.comment || '-' }}
            </div>
            <div v-else>
                <b-form-textarea
                    rows="1"
                    max-rows="2"
                    :value="substance.comment"
                    @input="$emit('substance-comment-change', group, substance, $event)"
                />
            </div>
        </td>
        <td>
            <template v-if="substanceListsText">
                <b-badge
                    v-for="(item, index) in substanceListsText.split(', ')"
                    :key="`list-${index}`"
                    class="ml-50"
                >
                    {{ item }}
                </b-badge>
            </template>
            <b-badge v-else>
                -
            </b-badge>
            <b-badge v-if="substanceListsExtra > 0" class="ml-50">
                +{{ substanceListsExtra }}
            </b-badge>
        </td>
        <td v-if="!readonly" class="text-center">
            <b-button size="sm" variant="danger" class="btn-icon" @click="$emit('remove-substance', group, substanceIndex)">
                <feather-icon icon="MinusIcon" />
            </b-button>
        </td>
    </tr>
</template>

<script>
import { BBadge, BButton, BFormTextarea } from 'bootstrap-vue'
import { FmdSubstanceFieldCell, FmdSubstanceWeightCell } from '@/views/product/components/product-card/fmd/common'

export default {
    name: 'FmdSubstanceRow',
    components: {
        BBadge,
        BButton,
        BFormTextarea,
        FmdSubstanceFieldCell,
        FmdSubstanceWeightCell,
    },
    props: {
        group: {
            type: Object,
            required: true,
        },
        substance: {
            type: Object,
            required: true,
        },
        substanceIndex: {
            type: Number,
            required: true,
        },
        materialLabel: {
            type: String,
            default: '',
        },
        componentName: {
            type: String,
            default: '',
        },
        substanceMeta: {
            type: String,
            default: '',
        },
        substanceOption: {
            type: Object,
            default: null,
        },
        materialWeightDisplay: {
            type: String,
            default: '-',
        },
        substanceWeightDisplay: {
            type: String,
            default: '-',
        },
        substanceError: {
            type: String,
            default: '',
        },
        substanceWeightError: {
            type: String,
            default: '',
        },
        showComment: {
            type: Boolean,
            default: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        touched: {
            type: Boolean,
            default: false,
        },
        searchFn: {
            type: Function,
            required: true,
        },
        substancePlaceholder: {
            type: String,
            default: '',
        },
        startTypingText: {
            type: String,
            default: '',
        },
        noOptionsText: {
            type: String,
            default: '',
        },
        allowNoSubstance: {
            type: Boolean,
            default: false,
        },
        noSubstanceLabel: {
            type: String,
            default: '',
        },
        requestAddText: {
            type: String,
            default: '',
        },
        deleteText: {
            type: String,
            default: '',
        },
        isSubstanceSelected: {
            type: Function,
            required: true,
        },
        substanceListsText: {
            type: String,
            default: '',
        },
        substanceListsExtra: {
            type: Number,
            default: 0,
        },
        layout: {
            type: String,
            default: 'material-first',
        },
    },
}
</script>
